import type { Movie } from "@/mocks/catalog";

type MovieCardProps = {
  movie: Movie;
  rank?: number;
};

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300">
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} ${movie.genre} 海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
          <i className="ri-star-fill"></i>
          {movie.rating.toFixed(1)}
        </span>
        {typeof rank === "number" && (
          <span className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-md bg-foreground-950/80 text-xs font-bold text-background-50">
            {rank}
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <div className="flex items-center gap-2">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
            {movie.genre}
          </span>
          <span className="text-xs text-foreground-500">{movie.year}</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-950">
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-500">
          {movie.region} · {movie.duration} · 导演 {movie.director}
        </p>
        <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {movie.summary}
        </p>
        <div className="mt-auto flex flex-wrap gap-1.5 pt-2">
          {movie.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-md border border-background-300/60 px-2 py-0.5 text-xs text-foreground-600"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}